import { SystemMode } from '@/types/system'

export default {
    namespaced: true,

    state: {
        systemMode: SystemMode.ONLINE_TRAINING,
        isLoaded3D: false, //3D资源是否加载完成
        enterScene: false,//进站/出站
        isShowEngineView:false,//是否显示引擎视图
        isConfirmLogout: false,//是否确认退出
        pixiInstance: null as any,//pixi实例
        engineInitialized: false,//引擎是否初始化
        engineConfigReady: false,//后端引擎配置是否获取完成
        examWindDirection: 0,//考试风向
        // engineView 直接定位属性
        engineViewPosition: {
            width: '100%' as string,
            height: '100%' as string,
            top: '0px' as string,
            left: '0px' as string,
            zIndex: 'unset' as string | number,
        },
        // flyReplay 相关状态
        showFlyReplay: false as boolean,
        flyReplayData: {
            title: '' as string,
            score: '' as string | number,
            isPass: true as boolean,
            rating: '' as string,
            abilityData: null as any,
            flightSummary: '' as string,
            trainingSuggestion: '' as string,
            windDirection: null as any,
            windSpeed: null as any,
            pageMode: 2 as number,
            enterMode: 2 as number,
            trainingId: '' as string,
            deviationInfo: {} as any,
            scenePictureUrl: '' as string,
            uavNestId: '' as string,
            uavSpecificationId: '' as string,
            enterPageMode: 1 as number, //进入页面模式 1: 训练或成绩页面 2: 成绩页面查看结果
        },
        logoUrl: '' as string | null | undefined,
        isShowLocalLogo: false as boolean,
    },

    mutations: {
        setSystemMode(state: any, systemMode: SystemMode) {
            state.systemMode = systemMode;
        },
        setIsLoaded3D(state: any, isLoaded3D: boolean) {
            state.isLoaded3D = isLoaded3D;
        },
        setEnterScene(state: any, enterScene: boolean) {
            state.enterScene = enterScene;
        },
        setIshowEngineView(state: any, isShowEngineView: boolean) {
            state.isShowEngineView = isShowEngineView;
        },
        setIsConfirmLogout(state: any, isConfirmLogout: boolean) {
            state.isConfirmLogout = isConfirmLogout;
        },
        setPixiInstance(state: any, pixiInstance: any) {
            state.pixiInstance = pixiInstance;
        },
        setEngineInitialized(state: any, engineInitialized: boolean) {
            state.engineInitialized = engineInitialized;
        },
        setEngineConfigReady(state: {engineConfigReady:boolean}, engineConfigReady: boolean):void {
            state.engineConfigReady = engineConfigReady;
        },
        setExamWindDirection(state: any, examWindDirection: number | null | string) {
            state.examWindDirection = examWindDirection;
        },
        setEngineViewPosition(state: any, position: { width: string, height: string, top: string, left: string, zIndex: string | number }) {
            state.engineViewPosition = position;
        },
        setShowFlyReplay(state: any, show: boolean) {
            state.showFlyReplay = show;
        },
        setFlyReplayData(state: any, data: Record<string, any>) {
            state.flyReplayData = { ...state.flyReplayData, ...data };
        },
        setLogoUrl(state: any, logoUrl: string | null | undefined) {
            state.logoUrl = logoUrl;
        },
        setIsShowLocalLogo(state: any, isShowLocalLogo: boolean) {
            state.isShowLocalLogo = isShowLocalLogo;
        },
    },

    actions: {
    },

    getters: {
        systemMode: (state: any) => state.systemMode,
        isOnlineTraining: (state: any) => state.systemMode === SystemMode.ONLINE_TRAINING,
        isPilotAssessment: (state: any) => state.systemMode === SystemMode.PILOT_ASSESSMENT,
        isLoaded3D: (state: any) => state.isLoaded3D,
        enterScene: (state: any) => state.enterScene,
        isShowEngineView: (state: any) => state.isShowEngineView,
        engineViewTransform: (state: any) => state.engineViewTransform,
        engineViewZIndex: (state: any) => state.engineViewZIndex,
        engineViewPosition: (state: any) => state.engineViewPosition,
        showFlyReplay: (state: any) => state.showFlyReplay,
        flyReplayData: (state: any) => state.flyReplayData,
    }
};
